import { LocationProvider, Router, Route } from 'preact-iso';
import { I18nProvider } from './i18n';
import { ConsentProvider } from './lib/consent';
import { AuthProvider } from './lib/auth';
import { ProfileProvider } from './state/profile';
import { GameDataProvider } from './state/game';
import { Landing } from './pages/Landing';
import { Login } from './pages/Login';
import { AuthCallback } from './pages/AuthCallback';
import { Onboarding } from './pages/Onboarding';
import { Play, Boards, Profile, PublicProfile, Info, Partners, MatchDetail, LeagueDetail, PartnerDetail } from './pages/app/pages';
import { AdminHome } from './pages/AdminHome';
import { AdminMatches } from './pages/AdminMatches';
import { AdminTournament } from './pages/AdminTournament';
import { AdminPartners } from './pages/AdminPartners';
import { AdminUsers } from './pages/AdminUsers';
import { AdminArticles } from './pages/AdminArticles';
import { AdminPrizes } from './pages/AdminPrizes';
import { AdminWinners } from './pages/AdminWinners';
import { AdminLeaderboard } from './pages/AdminLeaderboard';
import { AdminRules } from './pages/AdminRules';
import { AdminLeagues } from './pages/AdminLeagues';
import { AdminWaitlist } from './pages/AdminWaitlist';
import { AdminNewsletter } from './pages/AdminNewsletter';
import { AdminComments } from './pages/AdminComments';
import { AdminBroadcasts } from './pages/AdminBroadcasts';
import { AdminPartnerContributions } from './pages/AdminPartnerContributions';
import { PartnerSelf } from './pages/PartnerSelf';
import { PartnerLogin } from './pages/PartnerLogin';
import { AccountDelete } from './pages/AccountDelete';
import { Privacy } from './pages/Privacy';
import { Support } from './pages/Support';
import { Terms } from './pages/Terms';
import { CookieBanner } from './components/CookieBanner';
import { LegalModal } from './components/LegalModal';
import { Toast } from './components/Toast';

import './styles/tokens.css';
import './styles/landing.css';
import './styles/login.css';
import './styles/consent.css';
import './styles/admin.css';
import './styles/partner.css';
import './styles/toast.css';
import './styles/account.css';
import './styles/lang-switcher.css';
import './styles/app.css';
import './styles/header.css';
import './styles/onboarding.css';
import './styles/play.css';
import './styles/match.css';
import './styles/boards.css';
import './styles/sections.css';

export function App() {
  return (
    <LocationProvider>
      <I18nProvider>
        <AuthProvider>
          <ProfileProvider>
          <GameDataProvider>
          <ConsentProvider>
            <Router>
              <Route path="/:locale/login" component={Login} />
              <Route path="/:locale/auth/callback" component={AuthCallback} />
              <Route path="/:locale/onboarding" component={Onboarding} />
              <Route path="/:locale/play" component={Play} />
              <Route path="/:locale/match/:n" component={MatchDetail} />
              <Route path="/:locale/boards" component={Boards} />
              <Route path="/:locale/boards/league/:id" component={LeagueDetail} />
              <Route path="/:locale/profile" component={Profile} />
              <Route path="/:locale/u/:id" component={PublicProfile} />
              <Route path="/:locale/info" component={Info} />
              <Route path="/:locale/partners" component={Partners} />
              <Route path="/:locale/partners/:id" component={PartnerDetail} />
              <Route path="/:locale/admin" component={AdminHome} />
              <Route path="/:locale/admin/matches" component={AdminMatches} />
              <Route path="/:locale/admin/tournament" component={AdminTournament} />
              <Route path="/:locale/admin/partners" component={AdminPartners} />
              <Route path="/:locale/admin/users" component={AdminUsers} />
              <Route path="/:locale/admin/articles" component={AdminArticles} />
              <Route path="/:locale/admin/prizes" component={AdminPrizes} />
              <Route path="/:locale/admin/winners" component={AdminWinners} />
              <Route path="/:locale/admin/leaderboard" component={AdminLeaderboard} />
              <Route path="/:locale/admin/rules" component={AdminRules} />
              <Route path="/:locale/admin/leagues" component={AdminLeagues} />
              <Route path="/:locale/admin/waitlist" component={AdminWaitlist} />
              <Route path="/:locale/admin/newsletter" component={AdminNewsletter} />
              <Route path="/:locale/admin/comments" component={AdminComments} />
              <Route path="/:locale/admin/broadcasts" component={AdminBroadcasts} />
              <Route path="/:locale/admin/partner-contributions" component={AdminPartnerContributions} />
              <Route path="/:locale/partner/login" component={PartnerLogin} />
              <Route path="/:locale/partner" component={PartnerSelf} />
              <Route path="/:locale/account/delete" component={AccountDelete} />
              <Route path="/:locale/privacy" component={Privacy} />
              <Route path="/:locale/support" component={Support} />
              <Route path="/:locale/terms" component={Terms} />
              <Route path="/:locale" component={Landing} />
              <Route path="/auth/callback" component={AuthCallback} />
              <Route path="/onboarding" component={Onboarding} />
              <Route path="/play" component={Play} />
              <Route path="/match/:n" component={MatchDetail} />
              <Route path="/boards" component={Boards} />
              <Route path="/boards/league/:id" component={LeagueDetail} />
              <Route path="/profile" component={Profile} />
              <Route path="/u/:id" component={PublicProfile} />
              <Route path="/info" component={Info} />
              <Route path="/partners" component={Partners} />
              <Route path="/partners/:id" component={PartnerDetail} />
              <Route path="/admin" component={AdminHome} />
              <Route path="/admin/matches" component={AdminMatches} />
              <Route path="/admin/tournament" component={AdminTournament} />
              <Route path="/admin/partners" component={AdminPartners} />
              <Route path="/admin/users" component={AdminUsers} />
              <Route path="/admin/articles" component={AdminArticles} />
              <Route path="/admin/prizes" component={AdminPrizes} />
              <Route path="/admin/winners" component={AdminWinners} />
              <Route path="/admin/leaderboard" component={AdminLeaderboard} />
              <Route path="/admin/rules" component={AdminRules} />
              <Route path="/admin/leagues" component={AdminLeagues} />
              <Route path="/admin/waitlist" component={AdminWaitlist} />
              <Route path="/admin/newsletter" component={AdminNewsletter} />
              <Route path="/admin/comments" component={AdminComments} />
              <Route path="/admin/partner-contributions" component={AdminPartnerContributions} />
              <Route path="/partner/login" component={PartnerLogin} />
              <Route path="/partner" component={PartnerSelf} />
              <Route path="/account/delete" component={AccountDelete} />
              <Route path="/privacy" component={Privacy} />
              <Route path="/support" component={Support} />
              <Route path="/terms" component={Terms} />
              <Route default component={Landing} />
            </Router>
            <CookieBanner />
            <LegalModal />
            <Toast />
          </ConsentProvider>
          </GameDataProvider>
          </ProfileProvider>
        </AuthProvider>
      </I18nProvider>
    </LocationProvider>
  );
}
